// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"drop-zone_dropzone__2gV5u"};